import { EmailSubmitModel } from "../modelos/email/EmailSubmitModel";

export const INIT_EMAIL_FORM_DATA: EmailSubmitModel = {
    email: "",
    idsPassageiros: [],
    idsVendas: [],
  };